import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Async thunk for fetching website settings
export const fetchWebsiteSettings = createAsyncThunk(
  'websiteSettings/fetchWebsiteSettings',
  async (websiteType, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/Common/GetWebsiteSettings',
        { websiteType },
        { headers: { 'Content-Type': 'application/json-patch+json' } }
      );
      const data = JSON.parse(response.data.message);
      return { allSettings: data }; // Return the full data for shared access
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const websiteSettingsSlice = createSlice({
  name: 'websiteSettings',
  initialState: {
    settings: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebsiteSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWebsiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload.allSettings;
      })
      .addCase(fetchWebsiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectWebsiteSettings = (state) => state.websiteSettings.settings;
export default websiteSettingsSlice.reducer;


